import filter from 'lodash/filter';
import React from 'react';
import PropTypes from 'prop-types';
import Select from '@spothero/ui/select';

const getSelectItems = reservationTypes => {
    const activeItems = filter(reservationTypes, ({active, slug}) => {
        return active && slug !== 'all';
    });
    const items = activeItems.map(({name, slug}) => {
        return {
            label: name,
            value: slug
        };
    });

    items.unshift({
        label: reservationTypes.all.name,
        value: reservationTypes.all.slug
    });

    return items;
};

const AvailabilityFilters = ({
    activeReservationType,
    reservationTypes,
    onChange
}) => {
    return (
        <div className="AvailabilityFilters">
            <p className="AvailabilityFilters-description">Filter spots by availability below.</p>
            <Select
                className="reservation-type-select"
                items={getSelectItems(reservationTypes)}
                defaultValue={activeReservationType}
                onChange={onChange}
            />
            {activeReservationType !== 'all' &&
                <p className="reservation-type-detail">{reservationTypes[activeReservationType].description}</p>
            }
        </div>
    );
};

AvailabilityFilters.propTypes = {
    activeReservationType: PropTypes.string.isRequired,
    reservationTypes: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
};

export default AvailabilityFilters;
